import { invoke } from '@shared/easyfy.decorators';
import { globalEvent, element } from '@shared/easyfy.core';
import myPagesService from '@webServices/mypages.service';

namespace Easyfy.Web.Pages {
  @invoke
  class MyFavourites {
    static Instance: MyFavourites;

    static loaderString = '<div class="loader m-t-medium" role="status" aria-live="polite" aria-label="Laddar"></div>';

    static favouritesContainerElement: HTMLElement;

    static getFavouritesElement: HTMLElement;

    constructor() {
      MyFavourites.Instance = this;
    }

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'get-favourites',
          callback: MyFavourites.GetFavourites
        }
      });
      MyFavourites.favouritesContainerElement = element(
        '[data-container="favourites-container"]'
      ) as HTMLElement;
      MyFavourites.getFavouritesElement = element(
        '[data-action="get-favourites"]'
      ) as HTMLElement;
    }

    static GetFavourites = () => {
      MyFavourites.favouritesContainerElement.innerHTML =
        MyFavourites.loaderString;
      const currentPage =
        MyFavourites.getFavouritesElement.getAttribute('data-current-page');
      const nextPage = Number(currentPage) + 1;

      myPagesService
        .GetFavourites(nextPage)
        .then((response) => {

          if (response.status !== 200 || response.data.success === false) {
            MyFavourites.favouritesContainerElement.innerHTML = '';
            return;
          }

          MyFavourites.favouritesContainerElement.innerHTML = '';
          MyFavourites.favouritesContainerElement.insertAdjacentHTML(
            'beforebegin',
            response.data.favouritesPartial
          );

          MyFavourites.getFavouritesElement.setAttribute(
            'data-current-page',
            response.data.page
          );

          if (response.data.showMore === false) {
            MyFavourites.getFavouritesElement.remove();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    };
  }
}

export default Easyfy.Web.Pages;
